import { forwardRef, useContext } from 'react';

import { styled } from '@spazious/dollhouse-theme';

import { Flex, FlexElement, FlexProps } from '../Flex/index.js';

import { PanelContext } from './PanelContext.js';

export type PanelHeaderElement = FlexElement;

export interface PanelHeaderProps extends FlexProps {}

export const PanelHeader = styled(
  forwardRef<PanelHeaderElement, PanelHeaderProps>((props, ref) => {
    const ctx = useContext(PanelContext);

    if (!ctx) {
      throw new Error('PanelContent must be used within a Panel.');
    }

    const [{ top }] = ctx;

    return <Flex ref={ref} {...props} className={`${props.className} ${!top ? 'scolling' : ''}`} />;
  })
).withConfig({
  displayName: 'PanelHeader',
})<PanelHeaderProps>`
  padding: calc(2 * var(--spacing-padding));
  transition: box-shadow 0.2s ease-in-out;
  padding-bottom: var(--spacing-padding);
  &.scolling {
    box-shadow: rgba(0, 0, 0, 0.1) 0px 3px 5px -3px, rgba(0, 0, 0, 0.1) 1px 7px 11px -3px;
  }
`;
